import { useEffect } from "react";
import { useHistory } from "react-router-dom";

import { Loader } from "@transfr-inc/dashboard-components";

import { ProfileRoute, RootPath, UsersRoute } from "@lib/routes.config";

import { useCurrentUser } from "@queries/account";
import { useContainer } from "@src/contexts/container-context";
import { useAppStore } from "@src/stores/zustand/app-store";

export const Redirects = {
  TrekStudentComplete: "trk_ct",
  Profile: "prf",
};

export default () => {
  const { userService } = useContainer();
  const history = useHistory();

  const redirect = useAppStore((state) => state.redirect);
  const setRedirect = useAppStore((state) => state.setRedirect);
  const currentUser = useCurrentUser();

  useEffect(() => {
    if (redirect?.action) {
      onRedirect();
    }
  }, [redirect]);

  const onRedirect = async () => {
    let redirectFn;

    if (redirect.action === Redirects.TrekStudentComplete) {
      redirectFn = async () => {
        const { userId, classroomId, productId } =
          await userService.validateTrekCompleteToken(
            currentUser.userId,
            redirect.token
          );

        history.replace(
          `${RootPath}${UsersRoute.path}/${userId}?classroomId=${classroomId}&product=${productId}`,
          {
            userId,
            classroomId,
            product: productId,
            selectedProduct: productId,
            from: "dashboard",
          }
        );
      };
    } else if (redirect.action === Redirects.Profile) {
      redirectFn = async () => {
        history.replace(`${RootPath}${ProfileRoute.path}`);
      };
    }

    try {
      await redirectFn?.();
    } catch (error) {
      console.error("There was an error while processing redirection", error);
      setRedirect({ error: true });
      history.replace(RootPath);
    }
  };

  return (
    <div
      className="redirect-page"
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        flex: 1,
        justifyContent: "center",
      }}
    >
      <Loader />
      <h3>Redirecting...</h3>
    </div>
  );
};
